<template>
  <div class="animated fadeIn">
    <div class="container" v-bind:class="{ spinner: isBusy }">
      <div v-if="!isBusy">
        <span v-if="!surveyInstances">{{ $t("Webportal.NoDataFoundPlain") }}</span>

        <b-card class="mb-3" v-for="surveyInstance in surveyInstances" :key="surveyInstance.SurveyInstanceId">
          <template v-slot:header>
            <h5>{{ $t("Webportal.CheckInfo") }}</h5>

            <survey-revision-header class="pt-2" :surveyInstance="surveyInstance" />
          </template>

          <b-form-group>
            <b-button v-if="surveyInstance.CanCreateSurveyRevisionForExternalAccess" :disabled="surveyInstance.SurveyInstance.SurveyInstanceStatusId < 215 ||
              surveyInstance.SurveyInstance.SurveyInstanceStatusId >= 300" variant="primary" size="sm"
              @click="createSurveyRevision(surveyInstance)">
              <font-awesome-icon :icon="['fas', 'comment-exclamation']" size="lg" />&nbsp;
              {{ $t("Webportal.Actions.SurveyRevision.Create") }}
            </b-button>
          </b-form-group>

          <span v-if="!surveyInstance.SurveyRevisions" class="font-weight-light">
            {{ $t("Webportal.Actions.NoSurveyRevisionsFound") }}
          </span>

          <div v-else>
            <p v-if="$te('Webportal.Actions.SurveyRevision.StatusLinkHint')">
              <span class="text-danger">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
                {{ $t('Webportal.Actions.SurveyRevision.StatusLinkHint') }}
              </span>
            </p>

            <div class="d-flex flex-wrap">
              <survey-revision-card v-for="surveyRevision in surveyInstance.SurveyRevisions"
                :key="surveyRevision.SurveyRevisionId" :surveyRevision="surveyRevision" to="ExternalSurveyRevision" />
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import SurveyRevisionHeader from "@/components/Action/SurveyRevisionHeader";
import SurveyRevisionCard from "@/components/Action/SurveyRevisionCard";
import ActionService from "@/services/ActionService";
import SurveyRevisionMixin from "@/mixins/SurveyRevisionMixin";

export default {
  name: "SurveyRevisions",

  mixins: [SurveyRevisionMixin],

  components: {
    SurveyRevisionHeader,
    SurveyRevisionCard,
  },

  data() {
    return {
      isBusy: false,

      surveyInstances: null,
    };
  },

  created() {
    this.getSurveyInstances();
    EventBus.$on("LocalizationChanged", this.localizationChanged);
  },

  beforeUnmount() {
    EventBus.$off("LocalizationChanged", this.localizationChanged);
  },

  methods: {
    localizationChanged(localizationId) {
      this.getSurveyInstances();
    },

    getSurveyInstances() {
      this.isBusy = true;

      return ActionService.getSurveyInstances()
        .then((response) => {
          this.surveyInstances = response.data.items;
        })
        .finally((_) => {
          this.isBusy = false;
        });
    },

    createSurveyRevision(surveyInstance) {
      this.$router.push({ name: 'ExternalSurveyRevision', query: { sid: surveyInstance.SurveyInstance.SurveyInstanceId } })
    },
  },
};
</script>
